'use client'

import { useEnvironmentVariables } from '@/hooks/UseEnvironmentVariables'
import { GTMBodyScript } from '@/components/organisms/TagManager/GTMBodyScript'

export const GtmBodyLoader = () => {
    const { env } = useEnvironmentVariables()
    const gtmKey = env?.GTM_KEY

    if (!gtmKey) {
        return null
    }

    return <GTMBodyScript gtmKey={gtmKey} />
}
